var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt72 tac blank"},[_c('img',{attrs:{"src":require("@/assets/images/400.png")}}),_c('h1',[_vm._v("404")]),_c('p',{staticClass:"py24"},[_vm._v("抱歉，你访问的页面不存在")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push({ name: 'Home' })}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }